export default {
    ACCESS_MANAGEMENT_SET_PARTNERS_LOADING: 'ACCESS_MANAGEMENT_SET_PARTNERS_LOADING',
    ACCESS_MANAGEMENT_SET_SELECTED_PARTNER: 'ACCESS_MANAGEMENT_SET_SELECTED_PARTNER',
    ACCESS_MANAGEMENT_SET_SEARCH_PARTNER: 'ACCESS_MANAGEMENT_SET_SEARCH_PARTNER',
    ACCESS_MANAGEMENT_RESET_STATE: 'ACCESS_MANAGEMENT_RESET_STATE',
    ACCESS_MANAGEMENT_SET_SHOW_PARTNERS: 'ACCESS_MANAGEMENT_SET_SHOW_PARTNERS',
    ACCESS_MANAGEMENT_SET_SHOW_USERS: 'ACCESS_MANAGEMENT_SET_SHOW_USERS',
    ACCESS_MANAGEMENT_SET_SHOW_USER: 'ACCESS_MANAGEMENT_SET_SHOW_USER',
    ACCESS_MANAGEMENT_SET_SELECTED_USER: 'ACCESS_MANAGEMENT_SET_SELECTED_USER',
    ACCESS_MANAGEMENT_EDIT_APPLICATION: 'ACCESS_MANAGEMENT_EDIT_APPLICATION',
    ACCESS_MANAGEMENT_SET_SEARCH_USER: 'ACCESS_MANAGEMENT_SET_SEARCH_USER',
    ACCESS_MANAGEMENT_SET_FILTER_APPLICATION: 'ACCESS_MANAGEMENT_SET_FILTER_APPLICATION',
    ACCESS_MANAGEMENT_SET_FILTER_DEPARTMENT: 'ACCESS_MANAGEMENT_SET_FILTER_DEPARTMENT',
    ACCESS_MANAGEMENT_SET_SHOW_USER_MODAL: 'ACCESS_MANAGEMENT_SET_SHOW_USER_MODAL',
    ACCESS_MANAGEMENT_SET_MODE_USER_MODAL: 'ACCESS_MANAGEMENT_SET_MODE_USER_MODAL',
    ACCESS_MANAGEMENT_IS_DEVPARTNER: 'ACCESS_MANAGEMENT_IS_DEVPARTNER'
};